import React from 'react';
import classNames from 'classnames';
import InvisibleButton from '../../buttons/InvisibleButton';

type Props = {
  imgUrl?: string;
  onClick: () => void;
  'aria-label': string;
  imgAlt: string;
};

const UploadImageIcon = ({ imgUrl, onClick, imgAlt, ...rest }: Props) => (
  <InvisibleButton onClick={onClick} ariaLabel={rest['aria-label']}>
    <div className={classNames('upload-image-icon-v2', { 'no-img': !imgUrl })}>
      {imgUrl ? <img src={imgUrl} alt={imgAlt} /> : <i className="icon-ds-file-upload" />}
    </div>
  </InvisibleButton>
);

export default UploadImageIcon;
